const GlobalConst = {
  // qrcode settings
  qrHeadVersion: '0001',
  qrSize: 262,
  qrErrorLength: 900,
  
  // page titles
  titles: [
    {
      id: 1,
      name: '申請内容入力',
      leadText: '以下を入力してください',
    },
    {
      id: 2,
      name: '住民異動届',
      leadText: '以下を入力してください',
    },
    {
      id: 3,
      name: '住民票写し等',
      leadText: '以下を入力してください',
    },
    {
      id: 4,
      name: '印鑑登録証明書',
      leadText: '以下を入力してください',
    },
    {
      id: 5,
      name: 'マイナンバーカードの電子証明書の発行・更新',
      leadText: '以下を入力してください',
    },
  ]
};

export default GlobalConst;